import { CARE_PILLARS } from '../constants';

function CareSection() {
  return (
    <section id="care" className="bg-frost">
      <div className="mx-auto max-w-6xl px-6 py-20">
        <div className="flex flex-col justify-between gap-6 border-b border-line pb-8 lg:flex-row lg:items-end">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.22em] text-ocean">
              Filing notes
            </p>
            <h2 className="mt-3 max-w-3xl text-4xl font-black uppercase leading-tight tracking-normal text-midnight sm:text-5xl">
              The public record, made scannable.
            </h2>
          </div>
          <p className="max-w-md leading-8 text-muted">
            These points summarize the PDF in plain language for a clean business landing page.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {CARE_PILLARS.map((pillar) => (
            <article
              key={pillar.title}
              className="group grid min-h-[190px] grid-cols-[4.25rem_1fr] gap-5 rounded-2xl border border-line bg-paper p-6 transition hover:-translate-y-1 hover:border-ocean/40 hover:shadow-soft"
            >
              <span
                aria-hidden
                className="grid h-16 w-16 place-items-center rounded-xl bg-midnight text-lg font-black text-signal transition group-hover:bg-ocean group-hover:text-paper"
              >
                {pillar.code}
              </span>
              <div>
                <h3 className="text-2xl font-black text-midnight">{pillar.title}</h3>
                <p className="mt-3 leading-7 text-muted">{pillar.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CareSection;
